import {
  GET_QUESTIONS_SUCCESS,
  GET_QUESTIONS_START,
  GET_QUESTIONS_FAILURE,
} from '../actionTypes';

const initial_state = {
  all: [],
  loading: true,
};

export default (state = initial_state, action) => {
  switch (action.type) {

    case GET_QUESTIONS_START:
      return { ...state, loading: true }
    case GET_QUESTIONS_SUCCESS:
      return { ...state, loading: false, all: action.payload }
    case GET_QUESTIONS_FAILURE:
      return { ...state, loading: false }

    default: return { ...state };
  }
}
